import React from 'react';
import BlogListGeneric from '../../Generic/BlogListGeneric';

const BlogListKevin = () => {
    return (
      <BlogListGeneric postType="Kevin" heading="Kevin's Corner" />
  );
};

export default BlogListKevin;